<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-bodymatter element-container-group element-type-part element-with-heading full-character-formatting" epub:type="part" id="part-1" role="doc-part">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-with-element-number">
<div class="element-number-block">
<div class="element-number case-upper"><span class="element-number-term">Part</span> <span class="element-number-number">1</span></div>
</div>
<div class="title-block">
<h1 class="title case-upper">Arrival</h1>
</div>
<h2 class="subtitle case-upper">Morning, Last Day of Autumn</h2>
</div>
</div>
</div>
<div class="text" id="part-1-text">
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?69adfa38